import React, { useContext, useCallback, useEffect } from 'react';

import { UserStorageContext } from 'context/UserStorageContext';
import { OverlayTaskContext } from 'context/OverlayTaskContext';

import TaskContainer from 'containers/task-container';

import Task from 'components/task';
import Tooltip from 'components/tooltip';

import './MinimizedTasks.styles.css';

const TaskEntry = ({ id, nice_id, error, onClick, onError }) => {
    const handleClick = () => {
        onClick(id);
    }

    useEffect(() => {
        if (error) {
            onError(id);
        }
    }, [error]);

    if (!nice_id) {
        return null;
    }

    return (
        <Tooltip type="popout" className="taks-popout" tooltip={<Task id={id} showActions={false} onClick={handleClick} />}>
            <span className="nice-id" onClick={handleClick}>{ nice_id }</span>
        </Tooltip>
    );
}


const MinimizedTasks = ({ }) => {
    const userStorage = useContext(UserStorageContext);
    const overlayTask = useContext(OverlayTaskContext);

    const handleTaskClick = useCallback(id => {
        overlayTask?.openTask(id);
    }, [overlayTask?.openTask]);

    const handleTaskError = useCallback(id => {
        userStorage?.removeMinimizedTask(id);
    }, [userStorage?.removeMinimizedTask]);

    return (
        <div className="task-id-holder minimized-tasks">
            {
                (userStorage?.minimizedTasks || []).map(taskId => <TaskContainer id={taskId}><TaskEntry onClick={handleTaskClick} onError={handleTaskError} /></TaskContainer>)
            }
        </div>
    );
}

export default MinimizedTasks;
